import { buildProfileAddress } from './ProfileAddress';
export const serializeBillingFields = fields => [
    [fields.firstName, fields.lastName].filter(Boolean).join(' ').trim(),
    buildProfileAddress(fields.street, fields.village, fields.taluk, fields.district),
    [fields.city, fields.state, fields.pin].filter(Boolean).join(', '),
    'India', fields.phone && 'Phone: ' + fields.phone
].filter(Boolean).join('\n');
export const validateBillingFields = fields => {
    if (!String(fields.firstName || '').trim()) return 'Enter the billing first name.';
    if (!String(fields.street || '').trim()) return 'Enter the billing street address.';
    if (!fields.state) return 'Select the billing state.';
    if (!fields.city && !fields.district) return 'Select the billing city.';
    if (!/^\d{6}$/.test(fields.pin || '')) return 'Enter a six-digit billing PIN code.';
    if (!fields.village) return 'Select the billing village / locality.';
    if (serializeBillingFields(fields).length > 1000) return 'Keep the billing address within 1,000 characters.';
    return '';
};
